(function () {
  'use strict';
  if (window.__bnkPjax) return;
  if (!window.history || !window.history.pushState || !window.fetch || !window.DOMParser) return;
  window.__bnkPjax = true;

  var SEL = '#MainContent';
  var seq = 0;
  var bar = document.createElement('div');
  bar.className = 'pjax-bar';
  if (document.body) document.body.appendChild(bar);

  function main() { return document.querySelector(SEL); }

  // Nyitott menük bezárása navigáláskor (mega-menü + mobil drawer). PJAX-nál nincs
  // reload, ezért maguktól nyitva maradnának.
  function closeMenus() {
    var open = document.querySelectorAll('details.mega-menu[open], details.menu-drawer[open], header-drawer details[open], header-menu details[open]');
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var s = open[i].querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }
    // BIONIKA (2026-09-16): kereső-legördülő zárása. PJAX-nál nincs oldalbetöltés,
    // ezért a predictive search találati doboza (és a kereső-modál) nyitva maradt,
    // miután a látogató egy felkínált márka-/rendszer-kollekcióra kattintott.
    var pss = document.querySelectorAll('predictive-search');
    for (var p = 0; p < pss.length; p++) {
      try { if (typeof pss[p].close === 'function') pss[p].close(true); } catch (err) {}
    }
    var searches = document.querySelectorAll('.header__search details[open], details-modal.header__search details[open]');
    for (var k = 0; k < searches.length; k++) {
      var modal = searches[k].closest('details-modal');
      var done = false;
      if (modal && typeof modal.close === 'function') { try { modal.close(); done = true; } catch (err) {} }
      if (!done) {
        searches[k].removeAttribute('open');
        var ss = searches[k].querySelector('summary');
        if (ss) ss.setAttribute('aria-expanded', 'false');
      }
    }
    if (document.activeElement && document.activeElement.blur && document.activeElement.closest &&
        document.activeElement.closest('.header, header-menu, header-drawer, .header__search, predictive-search')) {
      document.activeElement.blur();
    }
  }
  // Aktív menüpont (pirula-kiemelés) frissítése: PJAX-nál a fejléc nem töltődik
  // újra, ezért a Liquid-féle .header__active-menu-item jelölés elavulna. Egy
  // top-level menüpont akkor aktív, ha bármely benne lévő link az aktuális útvonalra
  // mutat (a Liquid `current`/`child_active` logikájának megfelelője).
  function normPath(p) { return (p || '/').replace(/\/+$/, '') || '/'; }
  function refreshActiveMenu() {
    var path = normPath(location.pathname);
    var lis = document.querySelectorAll('.header__inline-menu > .list-menu--inline > li');
    for (var i = 0; i < lis.length; i++) {
      var item = lis[i].querySelector('summary.header__menu-item, a.header__menu-item');
      if (!item) continue;
      var active = false;
      var links = lis[i].querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) {
        var u; try { u = new URL(links[j].href, location.origin); } catch (_) { continue; }
        if (u.origin === location.origin && normPath(u.pathname) === path) { active = true; break; }
      }
      var span = item.querySelector('span');
      if (span) span.classList.toggle('header__active-menu-item', active);
    }
  }
  function barStart() {
    bar.classList.add('on'); bar.style.width = '20%';
    setTimeout(function () { if (bar.classList.contains('on')) bar.style.width = '72%'; }, 180);
  }
  function barDone() {
    bar.style.width = '100%';
    setTimeout(function () { bar.classList.remove('on'); bar.style.width = '0'; }, 260);
  }

  function eligible(a, e) {
    if (!a || e.defaultPrevented) return false;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    var tgt = a.getAttribute('target'); if (tgt && tgt !== '_self') return false;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-pjax')) return false;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return false;
    var url; try { url = new URL(a.href, location.origin); } catch (_) { return false; }
    if (url.origin !== location.origin) return false;
    if (!/^\/(collections|search)(\/|$|\?)/.test(url.pathname)) return false;
    // A Dawn facet-rendszert (saját AJAX) és a márkaválasztó linkjeit hagyjuk békén:
    if (a.closest('.facets, .mobile-facets, facet-remove, facet-filters-form, [data-mp-wrap], [data-brand-pick]')) return false;
    return true;
  }

  // innerHTML-lel beszúrt <script>-ok NEM futnak le → az inline-okat újra kell futtatni
  // (a külső, src-s scriptek már be vannak töltve; a custom elemek maguktól upgrade-elnek).
  function runInlineScripts(root) {
    var s = root.querySelectorAll('script');
    for (var i = 0; i < s.length; i++) {
      var old = s[i];
      if (old.src) continue;
      var ns = document.createElement('script');
      if (old.type) ns.type = old.type;
      ns.textContent = old.textContent;
      old.parentNode.replaceChild(ns, old);
    }
  }

  // ── Mennyiségi-kedvezmény app (OMG / Pareto „volume discount") szivárgás-őr ──────────
  // Ez a „mennyiségi kedvezményes táblázat" CSAK termékoldalon jogos. Az app scriptje a
  // PJAX-navigáció (SPA-szerű váltás) után néha a kollekció/kereső oldalra is beszúrja a
  // tábláját – és mivel aszinkron, „vándorol" (hol az 1., hol az 5. termék alatt jelenik
  // meg). Kollekció/kereső oldalon EZ MINDIG hibás, ezért ott eltávolítjuk: közvetlenül a
  // csere után ÉS egy MutationObserverrel a késői/aszinkron beszúrások ellen is.
  var VD_SEL = '.omg-groupsTable, .otTableOffer, .omg-offer, [id^="omg-offer"], [id*="pareto_volume_discount_app_block"]';
  function onListingPage() { return /^\/(collections|search)(\/|$|\?)/.test(location.pathname); }
  function stripVolumeDiscount() {
    if (!onListingPage()) return;                       // termékoldalon NE nyúljunk hozzá
    var els = document.querySelectorAll(VD_SEL);
    for (var i = 0; i < els.length; i++) {
      var n = els[i];
      // A quick-add modálban megjelenő termékoldal-tartalom NEM szivárgás: ott a
      // mennyiségi kedvezmény jogos, ne töröljük.
      if (n.closest && n.closest('quick-add-modal')) continue;
      var wrap = n.closest ? n.closest('[id*="pareto_volume_discount_app_block"]') : null;
      var kill = wrap || n;                             // a teljes app-blokk, vagy ha nincs, a tábla gyökere
      if (kill && kill.parentNode) kill.parentNode.removeChild(kill);
    }
  }
  // ── Sablon-specifikus stíluslapok pótlása ────────────────────────────────────────────
  // A theme.liquid a kollekció-kritikus CSS-t (template-collection, component-facets,
  // component-card, quick-add, …) a <head>-be tölti, `page_type == 'collection'`
  // feltétellel — így nem villan a régi elrendezés az első festés előtt. A PJAX viszont
  // CSAK a #MainContent-et cseréli, a <head>-et soha: termékoldalról kollekcióra lépve
  // egyetlen kollekció-CSS sem lenne betöltve (a .facets-vertical `display: flex`-e sem),
  // ezért a rács teljes szélességben a szűrő alá csúszna, a képek pedig méret nélkül
  // maradnának. A hiányzó lapokat itt pótoljuk, és MEGVÁRJUK a betöltésüket, hogy a
  // stílus nélküli elrendezés fel se villanjon.
  function ensureStylesheets(doc, done) {
    // A #MainContent-en BELÜLI linkeket NE számoljuk meglévőnek: azokat a csere kidobja
    // (pl. termékoldalon a component-card.css az ajánlott-termékek szekcióban él, és
    // nélküle a kollekció-kártyák 0 méretűek maradnak → a lazy képek be sem töltenek).
    var have = {}, cur = document.querySelectorAll('link[rel~="stylesheet"][href]');
    for (var i = 0; i < cur.length; i++) {
      if (cur[i].closest && cur[i].closest(SEL)) continue;
      have[cur[i].href] = 1;
    }
    var wanted = doc.querySelectorAll('link[rel~="stylesheet"][href]');
    var pending = 0, finished = false;
    function finish() { if (!finished) { finished = true; done(); } }
    for (var j = 0; j < wanted.length; j++) {
      var raw = wanted[j].getAttribute('href');
      if (!raw) continue;
      var abs; try { abs = new URL(raw, location.href).href; } catch (e) { continue; }
      if (have[abs]) continue;
      have[abs] = 1;
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = abs;
      pending++;
      l.onload = l.onerror = function () { if (--pending <= 0) finish(); };
      // A base.css ELÉ szúrjuk be (a hard-load head-sorrendet reprodukálva):
      // a kollekció-kritikus CSS-ek eredetileg a base.css előtt töltődnek, és több
      // azonos specificitású szabálynál a sorrend dönt — a base.css végére fűzve a
      // component-facets.css visszaállítaná pl. a rendezési select szögletes alapstílusát.
      var baseLink = document.head.querySelector('link[rel~="stylesheet"][href*="base.css"]');
      if (baseLink) document.head.insertBefore(l, baseLink);
      else document.head.appendChild(l);
    }
    if (pending === 0) finish();
    else setTimeout(finish, 2000);   // lassú/akadó CSS ne fagyassza be a navigációt
  }

  // ── Sablon-specifikus SCRIPTEK pótlása ───────────────────────────────────────────────
  // A kollekció-oldali JS-t (facets.js — a szűrő-checkboxok, a „minden szűrő törlése" és
  // a rendezés AJAX-a; show-more.js) a szekció tölti be, page_type-feltétellel.
  // Termékoldalról érkezve a <facet-filters-form> custom element definiálatlan maradna →
  // a szűrő kattintásra semmit sem csinálna. Ráadásul az innerHTML-lel beszúrt src-s
  // <script> tagek INERTEK (nem futnak le), ezért futtatható klónra kell cserélni őket.
  // Az execedSrc közös nyilvántartás: minden URL csak EGYSZER fut le (különben a
  // customElements.define másodszor kivételt dobna). Csak téma-asseteket (/assets/)
  // futtatunk, hogy app-/analitika-scriptek ne duplázódjanak; async=false tartja a
  // sorrendet. A custom elementek a define után maguktól upgrade-elnek a kész tartalmon.
  var execedSrc = {};
  (function () {
    var init = document.querySelectorAll('script[src]');
    for (var i = 0; i < init.length; i++) execedSrc[init[i].src] = 1;
  })();
  function assetUrl(node) {
    var raw = node.getAttribute('src');
    if (!raw) return null;
    var abs; try { abs = new URL(raw, location.href).href; } catch (e) { return null; }
    return abs.indexOf('/assets/') === -1 ? null : abs;
  }
  function runSrcScripts(root) {
    var s = root.querySelectorAll('script[src]');
    for (var i = 0; i < s.length; i++) {
      var abs = assetUrl(s[i]);
      if (!abs || execedSrc[abs]) continue;
      execedSrc[abs] = 1;
      var ns = document.createElement('script');
      ns.src = abs;
      ns.async = false;
      s[i].parentNode.replaceChild(ns, s[i]);
    }
  }
  function ensureScripts(doc) {
    var want = doc.querySelectorAll('script[src]');
    for (var j = 0; j < want.length; j++) {
      var abs = assetUrl(want[j]);
      if (!abs || execedSrc[abs]) continue;
      execedSrc[abs] = 1;
      var s = document.createElement('script');
      s.src = abs;
      s.async = false;
      document.head.appendChild(s);
    }
  }

  function swap(html, finalUrl, push, keepScroll, savedY, mySeq) {
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { location.href = finalUrl; return; }
    var nm = doc.querySelector(SEL), cm = main();
    if (!nm || !cm) { location.href = finalUrl; return; }
    ensureStylesheets(doc, function () { applySwap(doc, nm, cm, finalUrl, push, keepScroll, savedY, mySeq); });
  }

  function applySwap(doc, nm, cm, finalUrl, push, keepScroll, savedY, mySeq) {
    if (mySeq !== seq) return;   // a CSS-várakozás alatt újabb navigáció indult
    var t = doc.querySelector('title'); if (t) { document.title = t.textContent; }
    cm.innerHTML = nm.innerHTML;
    if (nm.className) cm.className = nm.className;
    cm.setAttribute('data-pjax-swapped', 'true');
    // BIONIKA (2026-09-02): az URL-t MÉG A BEÁGYAZOTT SCRIPTEK ELŐTT frissítjük. A márka-oldal
    // fejléc-szinkronja (brand-collection-header) a csere után azonnal fut, és a location
    // alapján dönt: ha az még a régi oldalt mutatta, „másik oldalon" hitte magát és
    // location.assign-nal teljes újratöltést indított (betölt → újratölt → tetejére ugrik).
    if (push === 'replace') {
      try { history.replaceState({ bnkPjax: 1 }, '', finalUrl); } catch (e) {}
    } else if (push) {
      try { history.pushState({ bnkPjax: 1 }, '', finalUrl); } catch (e) {}
    }
    runInlineScripts(cm);
    runSrcScripts(cm);
    ensureScripts(doc);
    // Kategória-váltásnál (alkategória-sáv) NE ugorjunk a lap tetejére — a látogató
    // maradjon a termékeknél (keepScroll a mentett pozíció); máskor a lap tetejére.
    // A célt AKTÍVAN visszaállítjuk (most + rAF + rövid timeout), hogy a linkek
    // „#main-collection-filters" horgonya / bármely késői script-görgetés NE húzza el.
    var targetY = keepScroll ? (savedY || 0) : 0;
    window.scrollTo(0, targetY);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { window.scrollTo(0, targetY); });
    setTimeout(function () { window.scrollTo(0, targetY); }, 40);
    // Globális szkriptek újrafuttatása az ÚJ tartalomra:
    document.dispatchEvent(new CustomEvent('bionika:content-swapped'));
    if (window.BionikaBrand && window.BionikaBrand.reapply) { try { window.BionikaBrand.reapply(); } catch (e) {} }
    if (window.BionikaUpdateCardTypes) { try { window.BionikaUpdateCardTypes(); } catch (e) {} }
    stripVolumeDiscount();                              // az app-tábla szivárgásának eltávolítása a csere után
    refreshActiveMenu();                                // pirula-kiemelés az új útvonal szerint
    cm.classList.remove('pjax-loading');                // a halványítás/haladássáv csak a
    barDone();                                          // tényleges csere után zárul
  }

  function go(rawUrl, push, keepScroll) {
    var savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var finalUrl = rawUrl;
    if (window.BionikaBrand && window.BionikaBrand.decorateUrl) {
      try { finalUrl = window.BionikaBrand.decorateUrl(rawUrl); } catch (e) {}
    }
    finalUrl = finalUrl.split('#')[0];      // „#main-collection-filters" horgony eltávolítása → nincs anchor-görgetés
    var my = ++seq;
    var cm = main();
    if (cm) cm.classList.add('pjax-loading');
    barStart();
    fetch(finalUrl, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (my !== seq) return;             // közben újabb navigáció indult → ezt eldobjuk
        swap(html, finalUrl, push, keepScroll, savedY, my);
      })
      .catch(function () { location.href = finalUrl; });   // hiba → sima teljes navigáció
  }

  // Publikus belépési pont a globális márkamotor számára. Így az URL-ben lévő
  // compatibility paraméterek szinkronizálása is csak a #MainContent tartalmát
  // cseréli, és nem indít teljes oldal-újratöltést.
  window.BionikaPjax = window.BionikaPjax || {};
  window.BionikaPjax.navigate = function (rawUrl, options) {
    options = options || {};
    closeMenus();
    go(rawUrl, options.replace ? 'replace' : (options.push === false ? false : true), !!options.keepScroll);
  };

  // BIONIKA (2026-08-31): a navigáció publikus API-ja — a márkaválasztó (bnk-brand-picker.js)
  // is ezen megy át, hogy a rendszer-választás NE teljes újratöltés legyen (haladássáv +
  // csak a #MainContent cseréje), mint minden más kollekció-link.
  window.BnkPjax = { go: go };

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!eligible(a, e)) return;
    e.preventDefault();
    closeMenus();                                    // menü/drawer bezárása kattintáskor
    var keepScroll = !!a.closest('.cat-siblings');   // alkategória-sávból: maradjon a termékeknél
    go(a.href, true, keepScroll);
  });

  // Vissza/előre gomb → az aktuális URL tartalmát töltjük be (nincs teljes reload).
  window.addEventListener('popstate', function () {
    closeMenus();
    go(location.href, false, true);
  });

  // Folyamatos őr: a kedvezmény-app aszinkron (és „vándorló") beszúrásait is elkapjuk.
  // A path-ellenőrzés miatt termékoldalon SOHA nem fut le eltávolítás, csak listaoldalon.
  if (window.MutationObserver && document.body) {
    var vdObs = new MutationObserver(function (muts) {
      if (!onListingPage()) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { stripVolumeDiscount(); return; }
      }
    });
    vdObs.observe(document.body, { childList: true, subtree: true });
  }
  stripVolumeDiscount();                                // induláskor is (biztonsági háló)
})();
